import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['Martín', 'Camila', 'Luciano', 'Sofía', 'Nicolás', 'Valentina', 'Agustín', 'Florencia', 'Tomás', 'Julieta', 'Diego', 'Carolina', 'Matías', 'Paula', 'Federico'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Luis'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerPopup();
    }, 5000);
    const interval = setInterval(() => {
      triggerPopup();
    }, 20000); // Every 20 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerPopup = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 4000);
  };
  return <AnimatePresence data-id="element-316">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-4 left-4 z-40 max-w-xs w-full" data-id="element-317">
          <div className="bg-white rounded-lg shadow-2xl border-l-4 border-green-500 p-4 flex items-start gap-3 relative overflow-hidden" data-id="element-318">
            <div className="flex-shrink-0" data-id="element-319">
              <div className="bg-green-100 rounded-full p-2" data-id="element-320">
                <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-321" />
              </div>
            </div>
            <div className="flex-1 pr-4" data-id="element-322">
              <p className="text-xs text-gray-500 font-semibold uppercase tracking-wider mb-1" data-id="element-323">
                Compra Verificada
              </p>
              <p className="text-sm text-gray-800 font-medium leading-tight" data-id="element-324">
                <span className="font-bold text-black" data-id="element-325">{data.name}</span> de{' '}
                {data.city} acaba de comprar el{' '}
                <span className="font-bold text-blue-900" data-id="element-326">
                  FITNESS MASTER PACK
                </span>
              </p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-327">Hace unos instantes</p>
            </div>
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-300 hover:text-gray-500" data-id="element-328">
              <X className="w-4 h-4" data-id="element-329" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}